"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var instantDiscountApi = _interopRequireWildcard(require("@/api/instantDiscountApi.js"));
var _edit = _interopRequireDefault(require("./edit.vue"));
var _opLog = _interopRequireDefault(require("./opLog.vue"));
var _detail = _interopRequireDefault(require("./detail.vue"));
var _opLogDetailDialog = _interopRequireDefault(require("./opLogDetailDialog.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 字典
var MARKETER_MAP = {
  1: '平台',
  2: '商家'
};
var ACTIVITY_TYPE_MAP = {
  1: '折扣'
};
var ACTIVITY_SCENE_MAP = {
  1: '线下门店核销'
};
var STATUS_MAP = {
  1: '长期有效',
  2: '指定时间段有效',
  3: '禁用'
};
var _default = exports.default = {
  components: {
    InstantDiscountEdit: _edit.default,
    InstantDiscountOpLog: _opLog.default,
    InstantDiscountDetail: _detail.default,
    InstantDiscountOpLogDetail: _opLogDetailDialog.default
  },
  data: function data() {
    return {
      constants: this.$constants,
      listPram: {
        activityName: '',
        marketer: null,
        activityType: null,
        supplierId: null,
        status: null,
        fuCardId: null,
        supportThirdParty: null,
        customerId: null,
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: true,
      supplierList: [],
      customerList: [],
      fukaList: [],
      deleteDialog: {
        visible: false,
        loading: false,
        row: {} // 当前要删除的活动行
      }
    };
  },
  mounted: function mounted() {
    this.initFromQuery();
    this.handlerGetListData();
    this.loadSupplierList();
    this.loadCustomerList();
    this.loadFukaList();
  },
  methods: {
    // 从路由 query 读取供应商筛选条件
    initFromQuery: function initFromQuery() {
      var _this$$route$query = this.$route.query,
        supplierId = _this$$route$query.supplierId,
        supplierName = _this$$route$query.supplierName;
      if (supplierId !== undefined && supplierId !== null && supplierId !== '') {
        this.listPram.supplierId = Number(supplierId) || supplierId;
      }
      if (supplierName) {
        // 把供应商塞到下拉，便于显示（如果供应商列表已加载过就不影响）
        var exists = this.supplierList.some(function (item) {
          return String(item.id) === String(supplierId);
        });
        if (!exists && supplierId) {
          this.supplierList.push({
            id: this.listPram.supplierId,
            supplierName: supplierName
          });
        }
      }
    },
    loadSupplierList: function loadSupplierList() {
      var _this = this;
      instantDiscountApi.supplierList().then(function (res) {
        _this.supplierList = res || [];
      });
    },
    loadCustomerList: function loadCustomerList() {
      var _this2 = this;
      instantDiscountApi.getMiniappList('').then(function (res) {
        _this2.customerList = res || [];
      });
    },
    loadFukaList: function loadFukaList() {
      var _this3 = this;
      instantDiscountApi.getFucardList('').then(function (res) {
        _this3.fukaList = (res || []).map(function (item) {
          return {
            id: item.id,
            name: item.card_name || item.cardName || item.name || item.title || '福卡'
          };
        });
      });
    },
    // 字典映射
    getMarketerName: function getMarketerName(val) {
      return MARKETER_MAP[val] || '-';
    },
    getActivityTypeName: function getActivityTypeName(val) {
      return ACTIVITY_TYPE_MAP[val] || '-';
    },
    getActivitySceneName: function getActivitySceneName(val) {
      return ACTIVITY_SCENE_MAP[val] || '-';
    },
    getStatusName: function getStatusName(val) {
      return STATUS_MAP[val] || '-';
    },
    // 供应商 id → name
    getSupplierName: function getSupplierName(supplierId) {
      if (supplierId === null || supplierId === undefined) return '-';
      var found = this.supplierList.find(function (s) {
        return s.id === supplierId;
      });
      return found ? found.supplierName : '-';
    },
    // 小程序 customerId → name
    getCustomerName: function getCustomerName(customerId) {
      if (customerId === null || customerId === undefined) return '-';
      var found = this.customerList.find(function (c) {
        return c.customerId === customerId;
      });
      return found ? found.appName : '-';
    },
    // 是否有第三方支付（fuCardId === -1 为微信支付）
    hasThirdParty: function hasThirdParty(row) {
      var list = row && Array.isArray(row.paymentList) ? row.paymentList : [];
      return list.some(function (p) {
        return p && p.fuCardId === -1;
      });
    },
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.handlerGetListData();
    },
    handleResetSearch: function handleResetSearch() {
      this.listPram = {
        activityName: '',
        marketer: null,
        activityType: null,
        supplierId: null,
        status: null,
        fuCardId: null,
        supportThirdParty: null,
        customerId: null,
        page: 1,
        limit: this.$constants.page.limit[0]
      };
      this.handlerGetListData();
    },
    handlerGetListData: function handlerGetListData() {
      var _this4 = this;
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (Object.keys(pram).length > 0) {
        this.listPram = _objectSpread(_objectSpread({}, this.listPram), pram);
      }
      this.listLoading = true;
      instantDiscountApi.instantDiscountList(this.listPram).then(function (data) {
        _this4.listData = data;
        _this4.listLoading = false;
      }).catch(function () {
        _this4.listLoading = false;
      });
    },
    handlerOpenEdit: function handlerOpenEdit(row) {
      this.$refs.editRef.openInit(row);
    },
    handlerOpenOpLog: function handlerOpenOpLog(row) {
      this.$refs.opLogRef.openInit(row.id, row.activityName);
    },
    handlerOpenDetail: function handlerOpenDetail(row) {
      this.$refs.detailRef.openInit(row.id);
    },
    handlerOpenLogDetail: function handlerOpenLogDetail(_ref) {
      var id = _ref.id,
        side = _ref.side;
      this.$refs.opLogDetailRef.openInit(id, side);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData();
    },
    // 打开删除确认弹窗
    handleDelete: function handleDelete(row) {
      this.deleteDialog.row = _objectSpread({}, row);
      this.deleteDialog.visible = true;
    },
    // 提交删除
    submitDelete: function submitDelete() {
      var _this5 = this;
      this.deleteDialog.loading = true;
      instantDiscountApi.instantDiscountDelete(this.deleteDialog.row.id).then(function () {
        _this5.$message.success('删除成功');
        _this5.deleteDialog.visible = false;
        _this5.handlerGetListData();
      }).finally(function () {
        _this5.deleteDialog.loading = false;
      });
    },
    // 弹窗关闭后清理状态
    handleDeleteDialogClosed: function handleDeleteDialogClosed() {
      this.deleteDialog.row = {};
      this.deleteDialog.loading = false;
    },
    getStatusTagType: function getStatusTagType(status) {
      switch (status) {
        case 1:
          return 'success';
        case 2:
          return 'warning';
        case 3:
          return 'info';
        default:
          return '';
      }
    },
    formatDateTime: function formatDateTime(val) {
      if (!val) return '-';
      var d = new Date(val);
      if (isNaN(d.getTime())) return '-';
      var pad = function pad(n) {
        return n < 10 ? '0' + n : '' + n;
      };
      return "".concat(d.getFullYear(), "-").concat(pad(d.getMonth() + 1), "-").concat(pad(d.getDate()), " ").concat(pad(d.getHours()), ":").concat(pad(d.getMinutes()), ":").concat(pad(d.getSeconds()));
    }
  }
};